import { useEffect, useRef, useState } from "react";
const START_SECONDS = 17 * 60 + 34; // 00:17:34

function pad(n: number) {
  return n.toString().padStart(2, "0");
}
export function Countdown({
  compact = false
}: {
  compact?: boolean;
}) {
  const [remaining, setRemaining] = useState(START_SECONDS);
  const ref = useRef<number | null>(null);
  useEffect(() => {
    ref.current = window.setInterval(() => {
      setRemaining(prev => prev <= 1 ? START_SECONDS : prev - 1);
    }, 1000);
    return () => {
      if (ref.current) window.clearInterval(ref.current);
    };
  }, []);
  const hours = Math.floor(remaining / 3600);
  const minutes = Math.floor(remaining % 3600 / 60);
  const seconds = remaining % 60;
  const units = [{
    v: pad(hours),
    l: "Horas"
  }, {
    v: pad(minutes),
    l: "Min"
  }, {
    v: pad(seconds),
    l: "Seg"
  }];
  if (compact) {
    return <span className="font-head font-800 tabular-nums tracking-wider text-white" data-id="element-65" data-mp="10aino5c7kn8d">
        {pad(hours)}:{pad(minutes)}:{pad(seconds)}
      </span>;
  }
  return <div className="flex items-center justify-center gap-2 sm:gap-3" data-id="element-66" data-mp="xzlrxovekuuy">
      {units.map((u, i) => <div key={u.l} className="flex items-center gap-2 sm:gap-3" data-id="element-67" data-mp="t1k5ctyrqdeq" data-mpi={i}>
          <div className="flex min-w-[58px] flex-col items-center rounded-xl bg-[#0a1a34] px-3 py-2 shadow-inner sm:min-w-[68px]" data-id="element-68" data-mp="17r9fheou9rr5">
            <span className="font-head text-2xl font-800 tabular-nums text-white sm:text-3xl" data-id="element-69" data-mp="12som9z8088c7">
              {u.v}
            </span>
            <span className="text-[10px] font-600 uppercase tracking-widest text-white/50" data-id="element-70" data-mp="a37oem1m7z8l">
              {u.l}
            </span>
          </div>
          {i < units.length - 1 && <span className="font-head text-2xl font-800 text-[#f5a623]" data-id="element-71" data-mp="o0nufwg01qzt">:</span>}
        </div>)}
    </div>;
}